//@ts-nocheck

// WINDOW LOAD
window.addEventListener('load', () => {

  // Ocultar programas-objetivo sin texto
  document.querySelectorAll('.programas-objetivo').forEach(el => {
    const p = el.querySelector('p');
    if (!p || p.textContent.trim() === '') {
      el.remove();
    }
  });

  // Remover programas-es-para-ti-si sin texto
  document.querySelectorAll('.programas-es-para-ti-si').forEach(el => {
    const p = el.querySelector('p');
    if (!p || p.textContent.trim() === '') {
      el.remove();
    }
  });

  // Ocultar image-block si tiene placeholder y agregar clase al padre
  document.querySelectorAll('.image-block').forEach(el => {
    if (el.querySelector('.placeholder-image')) {
      el.style.display = 'none';
      const parent = el.closest('.group-block');
      if (parent) {
        parent.classList.add('sin-imagen');
      }
    }
  });  

});

// DOCUMENT LOAD
document.addEventListener('DOMContentLoaded', function() {
  
  // Stories H1
  document.querySelectorAll('.articulo-top-texto-nombre h1 strong').forEach(el => {
    if (!el.textContent.trim().replace(/\uFEFF/g, '')) {
      el.style.display = 'none';
    }
  });

  // Stories Quotes
  document.querySelectorAll('body.template-article #MainContent[data-template="article.stories"] .articulo-custom-contenido h3').forEach(function(h3) {
    var imagenContainer = h3.previousElementSibling;
    if (imagenContainer && imagenContainer.querySelector('img')) {
      var wrapper = document.createElement('div');
      wrapper.className = 'quote';
      imagenContainer.parentNode.insertBefore(wrapper, imagenContainer);
      wrapper.appendChild(imagenContainer);
      wrapper.appendChild(h3);
    }
  });


  // Calendly Popup
  // Busca todos los links/botones que apunten a tu Calendly
  // Calendly bajo demanda
  (function () {
    var loading = null;
    function loadCalendly() {
      if (window.Calendly) return Promise.resolve();
      if (loading) return loading;
      loading = new Promise(function (resolve, reject) {
        var css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = 'https://assets.calendly.com/assets/external/widget.css';
        document.head.appendChild(css);
        var s = document.createElement('script');
        s.src = 'https://assets.calendly.com/assets/external/widget.js';
        s.async = true;
        s.onload = resolve;
        s.onerror = function () { loading = null; reject(); };
        document.head.appendChild(s);
      });
      return loading;
    }
    function getLink(e) {
      return e.target && e.target.closest ? e.target.closest('a[href*="calendly.com"]') : null;
    }
    // Precarga al acercarse, para que al hacer clic ya esté listo
    ['pointerover', 'touchstart', 'focusin'].forEach(function (t) {
      document.addEventListener(t, function (e) {
        if (getLink(e)) loadCalendly().catch(function () {});
      }, { passive: true, capture: true });
    });
    document.addEventListener('click', function (e) {
      var a = getLink(e);
      if (!a) return;
      e.preventDefault();
      var url = a.href;
      loadCalendly()
        .then(function () { Calendly.initPopupWidget({ url: url }); })
        .catch(function () { window.open(url, '_blank', 'noopener'); });
    });
  })();
  
});


// Ofuscar enlaces (delegación de eventos, sin MutationObserver)
(function () {
  function b64_to_utf8(str) {
    return decodeURIComponent(
      Array.prototype.map.call(atob(str), function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join('')
    );
  }
  function go(el) {
    var encoded = el.getAttribute('url');
    if (encoded) window.location.href = b64_to_utf8(encoded);
  }
  function findEl(e) {
    return e.target && e.target.closest ? e.target.closest('.esEnlace') : null;
  }
  document.addEventListener('click', function (e) {
    var el = findEl(e);
    if (!el) return;
    e.preventDefault();
    go(el);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = findEl(e);
    if (!el) return;
    e.preventDefault();
    go(el);
  });
})();


// Autoplay videos galeria productos
(() => {
  const init = (root = document) => {
    root.querySelectorAll('media-gallery').forEach((gallery) => {

      const items = gallery.querySelectorAll('.product-media');

      const playIfVisible = (container, visible) => {
        const deferred = container.querySelector('deferred-media');
        if (!deferred) return;

        const button = deferred.querySelector('.deferred-media__poster-button');

        // si ya se abrió el video, no hacer nada
        const isLoaded = deferred.classList.contains('loaded');

        if (visible && button && !isLoaded) {
          button.click();
        }
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          playIfVisible(entry.target, entry.isIntersecting && entry.intersectionRatio > 0.6);
        });
      }, {
        threshold: [0, 0.6, 1]
      });

      items.forEach(item => observer.observe(item));
    });
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', e => init(e.target));
})();